(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('MessaggioVoucherDeleteController',MessaggioVoucherDeleteController);

    MessaggioVoucherDeleteController.$inject = ['$uibModalInstance', 'entity', 'MessaggioVoucher'];

    function MessaggioVoucherDeleteController($uibModalInstance, entity, MessaggioVoucher) {
        var vm = this;

        vm.messaggioVoucher = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MessaggioVoucher.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
